<template>
  <div class="me">
    <h1 class="title">About Me</h1>
    <main class="info-box" style="position:relative;">
      <div class="portrait-box"><img class="portrait" :src="portraitImg" alt="Portarit"></div>
      <div class="name-box">
        <p class="name">涂小庆</p>
      </div>
      <div class="pome-box">
        <p>以代码为镜，可通逻辑；</p>
        <p>以人本为镜，可明得失。</p>
      </div>
      <el-divider content-position="left">
        <h2 class="divider-title">独白</h2>
      </el-divider>
      <div class="introduction-box">
        <p class="introduction">
          Hello, 我是涂小庆, 软件工程专业今年毕业了, 首先感谢大家访问我的博客网站, 大学的几年里, 我一直潜心研究软件开发技术, 一边上课一边自学积累经验, 给大家分享软件开发相关技术等等,
          我记得刚上大学时, 用C语言敲下人生第一个Hello World, 就深深的喜欢上它, 我喜欢一句话“冥冥中该来则来，无处可逃”。
          我喜欢上了软件开发, 喜欢坐在电脑前敲代码，喜欢跟一堆程序员聊天. 这辈子，我也逃不出去了，深深的陷了进来.
          从一开始的HTML静态页面, 到JavaScript, jQuery, 再到Vue, 以及后端的Java, Spring, MySQL 这其中经历太多摸爬滚打, 但幸运的是我坚持了下来,
          我希望今后也能一直坚持下去, 因为我深深的热爱着代码.
        </p>
        <p class="introduction">
          如果你也是正在学习的学生, 我希望我写的博客, 能够帮到你们, 少走一些弯路, 而不是直接Ctrl+C+V.另外, 如果你对本站有什么建议, 都可以扫一下网站底部的群二维码, 进群和大家一起交流学习.
        </p>
      </div>
      <el-divider content-position="left">
        <h2 class="divider-title">关于本站</h2>
      </el-divider>
      <div class="about-website-box">
        <p class="red"> <a class="clear-a" href="https://996.icu/#/zh_CN" target="_blank">本站顶帖996.ICU, 拒绝996从你我做起!</a></p>
      </div>
      <el-divider content-position="left">
        <h2 class="divider-title">第三方信息</h2>
      </el-divider>
      <div class="thirty-party-box">
        <el-tooltip content="Gitee" placement="top" effect="light">
          <a class="thirty-logo" href="https://gitee.com/china-number1" target="_blank">
            <svg t="1588657335874" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6878" width="200" height="200" class="icon" style="width: 2em !important; height: 2em !important;">
              <path d="M0 520.886c0-69.368 13.51-135.697 40.498-199.02 26.987-63.323 63.322-117.826 109.006-163.51 45.65-45.65 100.154-81.985 163.51-109.006A502.289 502.289 0 0 1 512 8.92c69.335 0 135.663 13.477 198.986 40.497 63.356 26.988 117.86 63.323 163.51 109.007 45.684 45.65 82.02 100.154 109.006 163.51A502.289 502.289 0 0 1 1024 520.852c0 111.318-32.504 211.472-97.511 300.494-64.975 88.989-148.48 150.825-250.484 185.476-5.351 0-9.348-0.99-11.99-2.973-2.676-1.982-4.196-3.997-4.526-6.012a59.458 59.458 0 0 1-0.495-8.984 7.663 7.663 0 0 1-0.991-3.006v-128.99c0-40.63-14.336-75.314-43.008-103.986 76.667-13.345 134.011-41.819 171.999-85.487 37.987-43.669 57.013-96.52 57.013-158.522 0-58.005-18.663-108.346-56.022-150.99 13.345-42.678 11-87.668-6.97-135.003-18.697-1.322-39.011 1.85-61.01 9.513-22 7.663-38.318 14.831-49.02 21.47-10.637 6.673-20.316 13.016-28.97 19.027-38.68-10.669-81.854-16.02-129.486-16.02-47.7 0-90.509 5.351-128.529 16.02-7.333-5.35-15.855-11.164-25.5-17.507-9.68-6.342-26.493-14.005-50.507-22.99-23.982-9.018-45.65-12.85-65.008-11.495-18.663 47.996-20.645 93.646-5.979 136.984-36.665 42.678-54.998 92.986-54.998 150.99 0 62.002 18.663 114.689 55.99 157.994 37.326 43.339 94.67 72.01 171.998 86.016a142.303 142.303 0 0 0-39.969 70.029c-56.683 13.972-96.355 3.963-119.015-30.06-42.017-61.308-79.674-83.307-113.003-65.965-4.69 4.657-3.997 9.48 1.982 14.501 6.012 4.988 14.996 11.66 27.02 19.985 11.99 8.357 20.976 17.507 26.987 27.515 0.661 1.322 2.51 6.177 5.517 14.502a831.917 831.917 0 0 0 8.985 23.981c2.973 7.663 8.654 16.186 17.011 25.5 8.324 9.349 18.003 17.178 29.003 23.52 11 6.309 26.161 11 45.485 14.006 19.324 2.972 41.323 3.138 65.998 0.495v100.484c0 0.991-0.165 2.643-0.495 5.021-0.33 2.312-0.991 3.964-1.982 4.955-0.991 1.024-2.345 2.015-4.03 3.039a12.52 12.52 0 0 1-6.474 1.486c-2.676 0-6.012-0.33-10.009-0.99-101.343-35.345-183.825-97.182-247.51-185.51C31.842 731.037 0 631.577 0 520.92z" p-id="6879"></path>
            </svg>
          </a>
        </el-tooltip>
        <el-tooltip content="QQ" placement="top" effect="light">
          <a class="thirty-logo" href="javascript:;" @click="swithQQInfoVisible">
            <svg t="1614337566776" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8385" width="200" height="200" class="icon" style="width: 2em !important; height: 2em !important;">
              <path d="M801.28 668.8c-21.333333 18.773333-49.92-61.226667-53.973333-49.066667A186.026667 186.026667 0 0 1 704 702.293333c-1.493333 1.706667 33.706667 14.506667 43.733333 41.6s28.16 67.413333-93.44 80.213334c-71.466667 7.68-123.093333-37.973333-128-37.546667a94.72 94.72 0 0 1-15.573333 0 144.213333 144.213333 0 0 1-16.64 0c-2.346667 0-26.026667 37.546667-132.053333 37.546667-82.133333 0-103.466667-51.626667-87.04-80.213334s44.16-36.693333 40.32-41.173333a220.373333 220.373333 0 0 1-40.32-67.413333 162.773333 162.773333 0 0 1-4.906667-15.573334c-2.986667-11.306667-25.813333 67.2-50.346667 49.066667s-21.333333-64-6.4-108.586667 56.32-87.68 56.746667-97.066666c1.706667-35.413333-3.413333-41.173333 0-50.56 7.893333-21.333333 17.28-12.8 17.28-23.466667 0-135.68 100.906667-245.76 225.28-245.76s225.28 110.08 225.28 245.76c0 5.12 13.44 0 20.053333 23.466667a250.453333 250.453333 0 0 1 0 50.56c0 12.8 34.133333 28.373333 52.266667 97.066666s0 100.906667-8.96 108.586667zM512 0a512 512 0 1 0 512 512A512 512 0 0 0 512 0z" fill="#249BE5" p-id="8386"></path>
            </svg>
          </a>
        </el-tooltip>
      </div>
    </main>
    <el-dialog title="扫码加入QQ群" width="300px" :center="true" :show-close="false" v-model="qqInfoDialogvVsible">
      <div class="text-center">
        <img class="img-qq-group-qrcode" :src="QQGroupQrCode" alt="">
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import portraitImg from '@/assets/tx.png'
import QQGroupQrCode from '@/assets/qq_group_qrcode.jpg'

export default defineComponent({
  setup() {
    const qqInfoDialogvVsible = ref<boolean>(false)
    const swithQQInfoVisible = () => {
      qqInfoDialogvVsible.value = !qqInfoDialogvVsible.value
    }
    return {
      portraitImg,
      swithQQInfoVisible,
      qqInfoDialogvVsible,
      QQGroupQrCode
    }
  },
})
</script>
<style lang="scss" scoped>
.me {
  .info-box {
    margin-top: 50px;
    font-size: 1rem;

    .divider-title {
      font-size: 1.1rem;
    }

    .portrait-box {
      text-align: center;
      img.portrait {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        border: 2.7px solid $theme-color;
        // border: 3px solid hsla(0,0%,100%,.3);
        position: relative;
        transition: transform 0.4s;

        &:hover {
          transform: translateY(-10px);
        }
      }
    }

    .name-box {
      user-select: none;
      padding: 15px 0;
      text-align: center;
      .name {
        font-size: 1.2rem;
        font-weight: bold;
      }
    }

    .pome-box {
      user-select: none;
      cursor: not-allowed;
      padding: 10px 0;
      text-align: center;
      text-shadow: 0.01rem 0.01rem 0.1rem #999;
      line-height: 2rem;
    }

    .introduction-box {
      padding: 10px 20px 30px 20px;
      .introduction {
        font-size: 1rem;
        list-style: disc outside none;
        line-height: 2em;
        text-indent: 2rem;
      }
    }

    .about-website-box {
      padding: 10px 0 30px 0;
      text-align: center;
      line-height: 2em;

      .red {
        font-size: 1.2rem;
        font-weight: bold;
        transition: all 0.5s;
        margin: 20px 0;
        a {
          color: brown;
        }
        &:hover {
          transform: scale(1.1);
        }
      }
    }

    .thirty-party-box {
      padding: 10px 0 30px 0;
      text-align: center;

      .thirty-logo {
        margin: 0 10px;
        transition: all 0.3s;
        display: inline-block;
        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }

  .img-qq-group-qrcode {
    width: 200px;
    height: 200px;
  }
}
</style>